import styled from 'styled-components';

const SecondHeader = styled.div`
  font-family: 'Georgia';
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 24px;
  color: #333;
  padding-bottom: ${(props) => props.paddingbottom};
  border-bottom: ${(props) => props.borderbottom};
`;

SecondHeader.defaultProps = {
  paddingbottom: '20px',
  borderbottom: '1px solid',
};

export default SecondHeader;
